"use client";
import { useScrollToRef } from "@2u-landing-pages/utils";
import Five9Chat from "../../components/Chatbot/Five9Chat";
import { Footer } from "./Footer";
import "./global.css";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { Section1 } from "./Section1";
import { Section10 } from "./Section10";
import { Section2 } from "./Section2";
import { Section3 } from "./Section3";
import { Section4 } from "./Section4";
import { Section5 } from "./Section5";
import { Section6 } from "./Section6";
import { Section7 } from "./Section7";
import { Section8 } from "./Section8";
import { Section9 } from "./Section9";

export const CuCyber = function () {
  const { ref, scrollTo } = useScrollToRef();

  return (
    <>
      <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
      {/* eslint-disable-next-line @next/next/no-page-custom-font */}
      <link
        rel="stylesheet"
        id="twoyou-google-fonts-css"
        href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&#038;family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&#038;display=swap"
        media="all"
      />
      <link
        rel="stylesheet"
        id="whitelabel-fonts-css"
        href="https://whitelabel.2u.com/cdn/v1/b2b57977-3799-4958-b13b-4db6f983e929/marketing/whitelabel.fonts.min.css?ver=1.0"
        media=""
      />
      <Header />
      <Hero ref={ref} />
      <Section1 scrollTo={scrollTo} />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 scrollTo={scrollTo} />
      <Section6 />
      <Section7 scrollTo={scrollTo} />
      <Section8 />
      <Section9 />
      <Section10 scrollTo={scrollTo} />
      <Footer />
      <Five9Chat
        configId="BC | BASE"
        campaignName="BC_Chat_Columbia"
        universitySfId="0014100000ZZfPzAAL"
        consentSchoolName="Columbia Engineering Boot Camps"
        program=""
        campus=""
        cohort=""
      />
      <script
        defer
        src="https://usa.bootcampcdn.com/wp-content/themes/CodingBootcamp/media/js/splidejs/splide-extension-intersection.min.js?ver=0.3.4"
      ></script>
    </>
  );
};
